import { render, staticRenderFns } from "./ManageEmailAction.vue?vue&type=template&id=3df5fc28&scoped=true&"
import script from "./ManageEmailAction.vue?vue&type=script&lang=js&"
export * from "./ManageEmailAction.vue?vue&type=script&lang=js&"
import style0 from "./ManageEmailAction.vue?vue&type=style&index=0&id=3df5fc28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df5fc28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df5fc28')) {
      api.createRecord('3df5fc28', component.options)
    } else {
      api.reload('3df5fc28', component.options)
    }
    module.hot.accept("./ManageEmailAction.vue?vue&type=template&id=3df5fc28&scoped=true&", function () {
      api.rerender('3df5fc28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/Email/ManageEmailAction.vue"
export default component.exports